import React, { useState, useEffect } from 'react'
import Cookies from 'js-cookie'
import axios from 'axios'
import { toast } from 'react-toastify'
import Select from 'react-select'
import Topbar from '../layouts/Topbar'
import Sidebar from '../layouts/Sidebar'
import { FaSave, FaSpinner } from 'react-icons/fa'
import 'react-toastify/dist/ReactToastify.css'
import '../../Employee/screens/CreateGoal.css'
import API_BASE_URL from '../../../config/api'

const quarterOptions = [
  { value: 'Q1', label: 'Quarter 1' },
  { value: 'Q2', label: 'Quarter 2' },
  { value: 'Q3', label: 'Quarter 3' },
  { value: 'Q4', label: 'Quarter 4' },
  { value: 'Weekly', label: 'Weekly' },
  { value: 'Monthly', label: 'Monthly' },
  { value: 'Ongoing', label: 'Ongoing' },
]

const monthOptions = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
]

const performanceStandardOptions = [
  { value: 'Monthly', label: 'MONTHLY' },
  { value: 'Quarterly', label: 'QUARTELY' },
  { value: 'Always', label: 'ALWAYS' },
  { value: 'As and when necessary', label: 'AS AND WHEN NECESSARY' },
  { value: 'As and when required', label: 'AS AND WHEN REQUIRED' },
  { value: 'Daily', label: 'DAILY' },
  { value: 'Annually in line with policies and procedures', label: 'ANNUALLY IN LINE WITH POLICIES AND PROCEDURES' },
  { value: 'Quarterly accurate records daily', label: 'QUARTELY ACCURATE RECORDS DAILY' }
]

const HRCreateGoal = () => {
  const baseUrl = API_BASE_URL
  const [loading, setLoading] = useState(false)
  const [fetchingKRAs, setFetchingKRAs] = useState(true)
  const [kras, setKras] = useState([])
  const [form, setForm] = useState({
    key_result_area: null,
    activity: '',
    metric: '',
    stakeholder: '',
    performance_standard: null,
    quarter: null,
    year: new Date().getFullYear(),
    week: '',
    month: null
  })

  // Generate years: current year and following year
  const currentYear = new Date().getFullYear()
  const years = [currentYear, currentYear + 1]

  useEffect(() => {
    const fetchKRAs = async () => {
      setFetchingKRAs(true)
      try {
        const token = Cookies.get('token')
        const response = await axios.get(`${baseUrl}/api/key-result-areas/?year=${encodeURIComponent(form.year)}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })

        setKras(response.data)
      } catch (err) {
        console.log(err)
        toast.error('Failed to fetch Key Result Areas.')
      } finally {
        setFetchingKRAs(false)
      }
    }
    fetchKRAs()
  }, [form.year])

  const kraOptions = kras.map(kra => ({
    value: kra.id,
    label: kra.name
  }))

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm({ ...form, [name]: value })
  }

  const handleYearChange = (e) => {
    const year = parseInt(e.target.value)
    setForm({ ...form, year, key_result_area: null })
  }

  const handleSelectChange = (selected, { name }) => {
    setForm({ ...form, [name]: selected })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      const token = Cookies.get('token')
      await axios.post(`${baseUrl}/api/goals/`, {
        key_result_area_id: form.key_result_area?.value,
        activity: form.activity,
        metric: parseInt(form.metric),
        stakeholder: form.stakeholder,
        performance_standard: form.performance_standard?.value,
        quarter: form.quarter?.value,
        week: form.quarter?.value === 'Weekly' ? parseInt(form.week) : null,
        month: form.quarter?.value === 'Monthly' ? parseInt(form.month?.value) : null,
        year: form.year
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      toast.success('Goal created successfully!')
      setForm({
        key_result_area: null,
        activity: '',
        metric: '',
        stakeholder: '',
        performance_standard: null,
        quarter: null,
        year: new Date().getFullYear(),
        week: '',
        month: null
      })
    } catch (err) {
      console.log(err.response.data)
      toast.error(err.response?.data || 'Failed to create goal.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Topbar />
      <Sidebar />
      <div className="create-goal-container">
        <div className="page-header">
          <div className="header-content">
            <div className="page-title">
              <h1>Create Key Performance Indicator</h1>
              <p>Add a new kpi to your performance management system</p>
            </div>
          </div>
        </div>
        <div className="content-wrapper">
          <div className="goal-form-container">
            <form onSubmit={handleSubmit} className="goal-form">
              <div className="form-group">
                <label>Year <span className="required">*</span></label>
                <select
                  name="year"
                  value={form.year}
                  onChange={handleYearChange}
                  required
                  className="form-input"
                  disabled={loading}
                >
                  {years.map(year => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Key Result Area <span className="required">*</span></label>
                  <Select
                    name="key_result_area"
                    value={form.key_result_area}
                    onChange={handleSelectChange}
                    options={kraOptions}
                    placeholder={fetchingKRAs ? 'Loading KRAs...' : 'Select Key Result Area'}
                    classNamePrefix="react-select"
                    isDisabled={loading || fetchingKRAs}
                  />
                </div>
                <div className="form-group">
                  <label>Period <span className="required">*</span></label>
                  <Select
                    name="quarter"
                    value={form.quarter}
                    onChange={handleSelectChange}
                    options={quarterOptions}
                    placeholder="Select Period"
                    classNamePrefix="react-select"
                    isDisabled={loading}
                  />
                </div>
              </div>

              {form.quarter?.value === 'Weekly' && (
                <div className="form-group">
                  <label>Week Number <span className="required">*</span></label>
                  <input
                    type="number"
                    name="week"
                    value={form.week}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder="Enter week number (1-52)"
                    min="1"
                    max="52"
                    disabled={loading}
                  />
                </div>
              )}

              {form.quarter?.value === 'Monthly' && (
                <div className="form-group">
                  <label>Month <span className="required">*</span></label>
                  <Select
                    name="month"
                    value={form.month}
                    onChange={handleSelectChange}
                    options={monthOptions}
                    placeholder="Select Month"
                    classNamePrefix="react-select"
                    isDisabled={loading}
                  />
                </div>
              )}

              <div className="form-group">
                <label>Activity <span className="required">*</span></label>
                <textarea
                  name="activity"
                  value={form.activity}
                  onChange={handleChange}
                  required
                  className="form-textarea"
                  placeholder="Describe the activity or task..."
                  rows="4"
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label>Performance Standard <span className="required">*</span></label>
                <Select
                  name="performance_standard"
                  value={form.performance_standard}
                  onChange={handleSelectChange}
                  options={performanceStandardOptions}
                  placeholder="Select Performance Standard"
                  classNamePrefix="react-select"
                  isDisabled={loading}
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Metric <span className="required">*</span></label>
                  <input
                    type="number"
                    name="metric"
                    value={form.metric}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder="Enter metric value"
                    min="0"
                    disabled={loading}
                  />
                </div>
                <div className="form-group">
                  <label>Stakeholder <span className="required">*</span></label>
                  <input
                    type="text"
                    name="stakeholder"
                    value={form.stakeholder}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder="Enter stakeholder name"
                    disabled={loading}
                  />
                </div>
              </div>

              <div className="form-actions">
                <button
                  type="submit"
                  className="submit-button"
                  disabled={loading || !form.key_result_area || !form.activity || !form.metric || !form.stakeholder || !form.quarter || !form.performance_standard || !form.year || (form.quarter?.value === 'Weekly' && !form.week) || (form.quarter?.value === 'Monthly' && !form.month)}
                >
                  {loading ? (
                    <>
                      <FaSpinner className="spinner" />
                      <span>Creating KPI...</span>
                    </>
                  ) : (
                    <>
                      <FaSave />
                      <span>Create KPI</span>
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default HRCreateGoal
